<template>
  <div class="kontrollerProgramsCrudComp">

    <div class="div_full_program" v-for="(param, index) in data" :key="index">
      <h4>Программа #{{ index+1 }}</h4>
      <div class="div_program">
        <label class="label_title" for="">Время, мин.</label>
        <input
          type="number"
          min="0"
          max="31"
          v-model="param.m"
          :class="[{'animated shake error_input': errors[`m${index}`]}, 'input_grey']"
          @click="resetError(`m${index}`)"
        >
      </div>
      <p class="p_err_min">{{ errors[`m${index}`] }}</p>
      <div class="div_program">
        <label class="label_title" for="">Стоимость, руб.</label>
        <input
          type="number"
          min="0"
          v-model="param.r"
          :class="[{'animated shake error_input': errors[`r${index}`] }, 'input_grey']"
          @click="resetError(`r${index}`)"
        >
      </div>
      <p class="p_err_min">{{ errors[`r${index}`] }}</p>
    </div>

    <div class="div_check">
      <input type="checkbox" id="all" v-model="isApplyAll">
      <label for="all" class="label_title">Применить для всех кресел</label>
    </div>

    <p class="p_err_main">{{errMain}}</p>

    <div class="div_btns">
      <button-comp :classBtn="'btn_orange_min'" :textBtn="'Сохранить'" :clickBtn="save"/>
    </div>

  </div>
</template>

<script>
export default {
  name: 'kontrollerProgramsCrudComp',
  props: {
  },
  data: function () {
    return {
      required: [
        'KONTROLLER_M0', 'KONTROLLER_R0',
        'KONTROLLER_M1', 'KONTROLLER_R1',
        'KONTROLLER_M2', 'KONTROLLER_R2',
        'KONTROLLER_M3', 'KONTROLLER_R3',
        'KONTROLLER_M4', 'KONTROLLER_R4',
        'KONTROLLER_M5', 'KONTROLLER_R5',
        'KONTROLLER_M6', 'KONTROLLER_R6',
        'KONTROLLER_M7', 'KONTROLLER_R7',
        'KONTROLLER_M8', 'KONTROLLER_R8',
        'KONTROLLER_M9', 'KONTROLLER_R9'
      ],
      moduleName: 'kontrollers',
      passwordConfirm: null,
      passwordNew: null,
      passwordCurrent: null,
      isApplyAll: false
    }
  },
  beforeCreate () {
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getOne`, { required: null })
  },
  components: {
  },
  computed: {
    id: function () { return this.$store.getters[`${this.moduleName}/getId`] },
    errMain: function () { return this.$store.getters[`${this.moduleName}/getErrMain`] },
    errors: function () { return this.$store.getters[`${this.moduleName}/getErrors`] },
    data: function () {
      let model = this.$store.getters[`${this.moduleName}/getOne`]
      let modelRequired = this.$helpers.mapper.modelRequired(this.required, model)
      let modelArray = []
      for (let i = 0; i < 10; i++) {
        let param = {}
        param[`m`] = modelRequired[`KONTROLLER_M${i}`].value
        param[`r`] = modelRequired[`KONTROLLER_R${i}`].value
        modelArray.push(param)
      };
      return modelArray
    }
  },
  methods: {
    save () {
      this.$store.dispatch(`${this.moduleName}/updatePrograms`, { data: this.data, isApplyAll: this.isApplyAll })
    },
    remove () {
      this.$store.dispatch(`${this.moduleName}/delete`, {
        passwordCurrent: this.passwordCurrent
      })
    },
    toAll () {
      this.$store.dispatch(`${this.moduleName}/toAll`)
    },
    resetError (param) {
      this.$store.commit(`${this.moduleName}/setErrors`, { param: param, value: null })
    },
    resetPasswords () {
      this.passwordConfirm = null
      this.passwordNew = null
      this.passwordCurrent = null
    }
  }
}
</script>

<style scoped lang="scss">

.kontrollerProgramsCrudComp {
  width: 350px;
  margin: 32px auto 32px auto;
}
.div_full_program {
  display: grid;
  grid-template-rows: auto auto auto auto auto;
  grid-template-columns: 1fr;
  grid-gap: 10px;
  margin-bottom: 15px;
}
.div_program {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 1fr;
}
.div_check {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 60px 1fr;
}
.div_check input {
  margin: auto 10px auto auto;
}
.div_check label {
  margin: auto;
}
.div_btns {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
}

@media screen and (max-width: 1140px){
}
@media screen and (max-width: 960px){
}
@media screen and (max-width: 720px){
}
@media screen and (max-width: 540px){
}
@media screen and (max-width: 480px){
  .kontrollerProgramsCrudComp{
    width: calc(100% - 32px);
  }
}
@media screen and (max-width: 320px){
  .kontrollerProgramsCrudComp label{
    margin: 0 0 10px 0;
  }
  .kontrollerProgramsCrudComp input{
    margin: 0 0 20px 0;
  }
  .kontrollerProgramsCrudComp button{
    margin: 12px 0 0 0;
  }
}
</style>
